import HealthVolumeMatrix from './HealthVolumeMatrix'

export {HealthVolumeMatrix}
export default HealthVolumeMatrix
